import React, { useState, useEffect} from "react";
import { connect } from "react-redux";
import data from "../../../../../assets/apiRoutes.json";
import LotList from "../../../../../im/common/lists/LotList";
import { FillFilters, loadDatasource } from "../../../../../common/Utils";
import { WM } from "../../../../../const/constants";

function LotTab(props) {
    const [triggerLoadData, setTriggerLoadData] = useState({
        filters: {
            RItem: props.rowId,
            Module: WM
        },
        filterTypes: {
            RItem: 'select',
            Module: 'select'
        }
    });
    return (
        <div className="FormMt">
            <LotList triggerLoadData={triggerLoadData}  selectionMode="none" gridClassName="GridHeightTabPanel-with-toolbar"/>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotTab);